/**
 * Generate confirmation email HTML for user
 */
export const generateConfirmationEmailHTML = (userName) => {
    return `
<!DOCTYPE html>
<html lang="pt">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Confirmação de Pedido - FielCarga</title>
</head>
<body style="margin: 0; padding: 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: #f5f5f5;">
    <table role="presentation" style="width: 100%; border-collapse: collapse; background-color: #f5f5f5;">
        <tr>
            <td align="center" style="padding: 40px 20px;">
                <table role="presentation" style="max-width: 600px; width: 100%; border-collapse: collapse; background-color: #ffffff; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                    <!-- Header -->
                    <tr>
                        <td style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 30px; text-align: center; border-radius: 10px 10px 0 0;">
                            <h1 style="margin: 0; color: #ffffff; font-size: 28px; font-weight: 600;">FielCarga</h1>
                            <p style="margin: 10px 0 0 0; color: #ffffff; font-size: 16px; opacity: 0.9;">Transportes & Mudanças</p>
                        </td>
                    </tr>
                    
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 24px; font-weight: 600;">Olá ${userName},</h2>
                            
                            <p style="margin: 0 0 20px 0; color: #555555; font-size: 16px; line-height: 1.6;">
                                Recebemos o seu pedido de contacto e agradecemos o seu interesse nos nossos serviços!
                            </p>
                            
                            <p style="margin: 0 0 20px 0; color: #555555; font-size: 16px; line-height: 1.6;">
                                A nossa equipa profissional e responsável está a analisar o seu pedido e entrará em contacto consigo o mais breve possível.
                            </p>
                            
                            <div style="background-color: #f8f9fa; border-left: 4px solid #667eea; padding: 20px; margin: 30px 0; border-radius: 5px;">
                                <p style="margin: 0; color: #333333; font-size: 16px; font-weight: 600;">
                                    O nosso compromisso é consigo!
                                </p>
                                <p style="margin: 10px 0 0 0; color: #555555; font-size: 14px; line-height: 1.6;">
                                    Trabalhamos com dedicação para garantir que a sua mudança ou transporte seja realizado com a máxima qualidade e segurança.
                                </p>
                            </div>
                            
                            <p style="margin: 30px 0 20px 0; color: #555555; font-size: 16px; line-height: 1.6;">
                                Se tiver alguma questão urgente, não hesite em contactar-nos:
                            </p>
                            
                            <table role="presentation" style="width: 100%; border-collapse: collapse; margin: 20px 0;">
                                <tr>
                                    <td style="padding: 10px 0; color: #555555; font-size: 14px;">
                                        <strong>Telefone:</strong> (+351) 914 440 333
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 10px 0; color: #555555; font-size: 14px;">
                                        <strong>Email:</strong> geral@fielcarga.pt
                                    </td>
                                </tr>
                            </table>
                            
                            <p style="margin: 30px 0 0 0; color: #555555; font-size: 16px; line-height: 1.6;">
                                Com os melhores cumprimentos,<br>
                                <strong style="color: #667eea;">Equipa FielCarga</strong>
                            </p>
                        </td>
                    </tr>
                    
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #f8f9fa; padding: 30px; text-align: center; border-radius: 0 0 10px 10px;">
                            <p style="margin: 0 0 10px 0; color: #888888; font-size: 12px;">
                                © ${new Date().getFullYear()} FielCarga. Todos os direitos reservados.
                            </p>
                            <p style="margin: 0; color: #888888; font-size: 12px;">
                                Alvará nº 669921
                            </p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>
    `;
};

